import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getCopayInfo = (companyId: string, hpCode: string, optCode: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_COPAY_INFO_REQUEST });

  return api.eligibility.copay.getInfo(companyId, hpCode, optCode)
    .then((res: any) => {

      dispatch({
        type: types.GET_COPAY_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_COPAY_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
